<template>
  <div class="app-main-content">
    <div class="tabs-container">
      <el-tabs v-model="activeTabName" type="card" style="width:100%">
        <el-tab-pane v-if="branchTransactions" :lazy="true" :label="$t('SeaExport.branchTransactions')" name="branchTransactions">
          <branch-transactions />
        </el-tab-pane>
        <el-tab-pane v-if="supplierCharge" :lazy="true" :label="$t('SeaExport.supplierCharge')" name="supplierCharge">
          <supplier-charge />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import branchTransactions from '@/views/cargo/v0/Clearing/components/ChargeConfirmed/branchTransactions'
import supplierCharge from '@/views/cargo/v0/Clearing/components/ChargeConfirmed/supplierCharge'
import checkPermission from '@/utils/permission'

export default {
  name: 'ChargeConfirmed',
  components: {
    branchTransactions,
    supplierCharge
  },
  data() {
    return {
      activeTabName: 'branchTransactions',
      branchTransactions: false,
      supplierCharge: false
    }
  },
  created() {
    this.branchTransactions = checkPermission(['tab_ChargeConfirmed_BranchTransactions'])
    this.supplierCharge = checkPermission(['tab_ChargeConfirmed_SupplierCharge'])
    if (this.branchTransactions) {
      this.activeTabName = 'branchTransactions'
    } else if (this.supplierCharge) {
      this.activeTabName = 'supplierCharge'
    }
  },
  beforeMount() {
  },
  mounted() {
  },
  methods: {}
}
</script>

<style lang="scss">
</style>
